module.exports = __webpack_public_path__ + "static/thumbnail-f0136796abed166d9889e0f23781addf.webp";